<template>
  <v-row>
    <v-col>
      <v-card
        :class="$vuetify.breakpoint.xsOnly ? 'pa-4' : 'py-6 px-12'"
        no-body
      >
        <v-timeline dense>
          <v-timeline-item
            v-for="(item, index) in leaveTimeline"
            :key="index"
            :color="item.color"
          >
            <v-card outlined>
              <v-row>
                <v-col class="pa-6">
                  <div>
                    <span>{{ item.name }}</span>
                    <span v-if="item.date"> , เมื่อ {{ item.date }}</span>
                  </div>
                  <div>
                    <span>{{ item.approved }}</span>
                  </div>
                  <div v-if="item.reject" class="error--text">
                    <span>
                      ถูกตีกลับ : {{ item.reject.date }} จาก
                      {{ item.reject.name }}
                    </span>
                  </div>
                  <div v-if="item.reject" class="error--text">
                    <span>
                      เหตุผลการตีกลับ : {{ item.reject.description }}
                    </span>
                  </div>
                  <div v-if="item.reason">
                    <span>เหตุผล : {{ item.reason }}</span>
                  </div>
                  <div v-if="index === 0 && item.approveStatusID === 'W'">
                    <v-btn
                      class="mx-2 mt-2"
                      color="success"
                      small
                      depressed
                      @click="onApprove(item, index)"
                    >
                      อนุญาตใบลา
                    </v-btn>
                    <v-btn
                      class="mx-2 mt-2"
                      color="secondary"
                      small
                      depressed
                      @click="onCancel(item, index)"
                    >
                      ยกเลิกใบลา
                    </v-btn>
                    <v-btn
                      class="mx-2 mt-2"
                      color="purple lighten-2"
                      small
                      depressed
                      dark
                      @click="onReject(item, index)"
                    >
                      ตีกลับไปให้คนก่อนหน้า
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </v-timeline-item>
        </v-timeline>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    leaveTimeline: {
      type: Array,
      default: () => []
    }
  },

  methods: {
    async onApprove(item, index) {
      const count = this.leaveTimeline.length - index
      await this.onSubmit({
        LeaveOrderID: this.$route.params.leaveOrderId,
        ApproveNumber: count,
        LeaveEmployeeID: this.$route.params.guid,
        ApproveStatusID: 'A',
        SendEmployeeID: this.$route.params.guid,
        Description: 'เห็นควรพิจารณาอนุญาต'
      })
    },

    async onCancel(item, index) {
      const count = this.leaveTimeline.length - index
      await this.onSubmit({
        LeaveOrderID: this.$route.params.leaveOrderId,
        ApproveNumber: count,
        LeaveEmployeeID: this.$route.params.guid,
        ApproveStatusID: 'C',
        SendEmployeeID: this.$route.params.guid,
        Description: 'ยกเลิกการลา'
      })
    },

    async onReject(item, index) {
      const count = this.leaveTimeline.length - index
      await this.onSubmit({
        LeaveOrderID: this.$route.params.leaveOrderId,
        ApproveNumber: count,
        LeaveEmployeeID: this.$route.params.guid,
        ApproveStatusID: 'B',
        SendEmployeeID: this.$route.params.guid,
        Description: 'ตีกลับ'
      })
    },

    async onSubmit(body) {
      try {
        await this.$store.dispatch('leave/postCreateApproval', body)
        this.$emit('reload')
      } catch (e) {
        console.log(e.response || e)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
